export interface IRegisterRequest {
    ano: number;
    lstVariables: string | null;
    hasTitles: boolean;
    hasNormallizedTitles: boolean;
    showHiddenFields: boolean;
}